import { useState, useEffect, useCallback } from 'react';
import { ApiClient } from '@utils/apiClient';
import { handleApiResult } from '@utils/apiErrorHandler';

export interface QuotaStatus {
  max_agents: number | null;
  current_agents: number;
  agents_limit_reached: boolean;
  max_phone_numbers: number | null;
  current_phone_numbers: number;
  phone_numbers_limit_reached: boolean;
  included_minutes_monthly: number;
  included_minutes_used: number;
  included_minutes_used_seconds: number;
  included_minutes_remaining: number;
  included_phone_numbers: number;
}

const QUOTA_ENDPOINT = '/billing/quota/';

export function useQuota() {
  const [quota, setQuota] = useState<QuotaStatus | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchQuota = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await ApiClient.get(QUOTA_ENDPOINT);
      const result = await handleApiResult<QuotaStatus>(response, 'Failed to load quota');
      if (result.success && result.data) {
        setQuota(result.data);
        setError(null);
      } else {
        setError('Failed to load quota');
      }
    } catch (err) {
      setError('Failed to load quota');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchQuota();
  }, [fetchQuota]);

  return {
    quota,
    isLoading,
    error,
    refresh: fetchQuota,
  };
}
